<template>
    <transition name="modal custom-modal">
        <div class="modal-mask modal-lg">
            <div class="modal-wrapper">
                <div class="modal-container">
                    
                    <div class="modal-header">
                        <button type="button" class="close" @click="$emit('close')">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                        <h3 style="width: initial;"><i class="fa fa-lg fa-info-circle"></i> Client #{{ client.client_lookup_code }} <small>[{{ client.id  }}]</small></h3>
                    </div>
                    
                    <div class="modal-body pre-scrollable" v-bind:style="{'max-height': bodyHeight + 'px'}">
                        <div class="lead-detail">
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-xs-6 bg-dark lead-data">
                                        <h4>Details</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Account Name</th><td>{{ client.account_name }}</td><tr>
                                                    <tr><th>Client Lookup Code</th><td>{{ client.client_lookup_code }}</td></tr>
                                                    <tr><th>Client Id</th><td>{{ client.client_id }}</td></tr>
                                                    <tr><th>Format</th><td>{{ client.format_option }} <span v-if="client.inactive_reason">({{ client.inactive_reason }})</span></td></tr>
                                                    <tr><th>Source</th><td>{{ client.account_source }}</td></tr>
                                                    <tr><th>Email</th><td>{{ client.accountvalue_accountemail }}</td></tr>
                                                    <tr><th>Phone</th><td><span v-if="client.accountvalue_phonecountrycode">(+{{ client.accountvalue_phonecountrycode }})</span> {{ client.accountvalue_number }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 bg-dark lead-data">
                                        <h4>Address</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Street</th><td>{{ client.accountvalue_address_street1 }}</td></tr>
                                                    <tr><th>Street 2</th><td>{{ client.accountvalue_address_street2 }}</td></tr>
                                                    <tr><th>City</th><td>{{ client.accountvalue_address_city }}</td></tr>
                                                    <tr><th>County</th><td>{{ client.accountvalue_address_county }}</td></tr>
                                                    <tr><th>Zip or Postal Code</th><td>{{ client.accountvalue_address_ziporpostalcode }}</td></tr>
                                                    <tr><th>State or Province Code</th><td>{{ client.accountvalue_address_stateorprovincecode }}</td></tr>
                                                    <tr><th>Country</th><td>{{ client.accountvalue_address_countrycode }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-xs-12 bg-dark lead-data">
                                        <h4>Branches</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr v-for="branch in client.accountvalue_structure_branches"><td><span class="label">{{ branch.code }}</span> {{ branch.description  }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-xs-12 bg-dark lead-data">
                                        <h4>Policies</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <div class="table-responsive">
                                                <table class="table table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Policy Number</th>
                                                            <th>Policy Id</th>
                                                            <th>Type Code</th>
                                                            <th>Description</th>
                                                            <th>Effective Date</th>
                                                            <th>Expiration Date</th>
                                                            <th>Billed Premiun</th>
                                                            <th>Estimated Premium</th>
                                                            <th>Annualized Premium</th>
                                                            <th>Downloaded Premium</th>
                                                            <th>Billed Commission</th>
                                                            <th>Estimated Commission</th>
                                                            <th>Annualized Commission</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="policy in client.policies">
                                                            <td>{{ policy.policy_number }}</td>
                                                            <td>{{ policy.policy_id }}</td>
                                                            <td>{{ policy.policy_type_code }}</td>
                                                            <td>{{ policy.description }}</td>
                                                            <td>{{ policy.effective_date | formatDate }}</td>
                                                            <td>{{ policy.expiration_date | formatDate }}</td>
                                                            <td>${{ policy.billed_premium }}</td>
                                                            <td>${{ policy.estimated_premium }}</td>
                                                            <td>${{ policy.annualized_premium }}</td>
                                                            <td>${{ policy.downloaded_premium }}</td>
                                                            <td>${{ policy.billed_premium }}</td>
                                                            <td>${{ policy.estimated_commission }}</td>
                                                            <td>${{ policy.annualized_commission }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>

export default {
  name: 'EpicClientModal',
  props: {
    client: {
      type: Object
    }
  },
  data: function () {
    return {
    };
  },
computed: {
   bodyHeight () {
     return $(window).height() - 200;
   }
  },

  methods: {

  }
}
</script>
<style scoped>
 .panel-body div.lead-data {
     padding:10px;
 }
  .panel-body div.lead-data + div {
  margin-top: 0px!important;
  }

 .panel-body .row {
     background-color: #f7f7f7;
 }
 .modal-header h3 {
  text-transform: unset!important;
  }

  .lead-detail .panel-body h4 button {
  right: 20px;
  top: 10px;
  position: absolute;
  }
  
  .lead-detail .panel-body > div {
  padding: 10px 20px;
  }

  .lead-detail .panel-body > div.fields-list-wrapper {
  padding: 0px;
  }
  
  .lead-detail h4 {
  padding-bottom: 10px;
  }
  
  .bg-dark {
  background-color: #f7f7f7;
  border-radius: 4px 4px;
  }
  ul.contact-info li i {
  color: #aaa;
  }
  ul.contact-info > li:not(:first-child)::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #dadada;
  width: .75em;
  margin-left: 20px;
  margin-right: 20px;
  }
  ul.contact-info li {
  display: inline-block;
  }

  .score-model-name {
  font-weight: 700;
  }
  .score-model-date {
  font-weight: 700;
  }
  .score-value {
  font-weight: 700;
  font-size: 2.75em;
  color: #ff4d50;
  text-align: right;
  padding-left: 30px;
  min-width: 50%;
  }

  .fields-list-wrapper > div {
  padding: 10px 20px;
  }
  
  .fields-list-wrapper > div.lead-fields {
  margin-right: 10px;
  }
  
  .fields-list-wrapper div.crm-fields {
  margin-left: 10px;
  }

  .lead-detail table {
  border-radius: 4px;
  }
  
  .lead-detail .table > tbody > tr > td {
  padding: 10px 10px;
  }
  
  .lead-detail th {
  background-color: initial;
  color: initial;
  }

  .service-title {
    text-transform: uppercase;
  }

  .lead-data table {
    overflow-x: auto;
  }

</style>



// WEBPACK FOOTER //
// EpicClientModal.vue?af1dd6d8